//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { insertBaseInfo } from '@/https/enroll'
import {
  danger,
  success,
} from '@/utils/notify'
import { SAVE_SUCCESS } from '@/constant/tips'
import { confirm } from '@/utils/dialog'
import TDynamicForm from '@/TShareComponent/TDynamicForm'

export default {
  components: { TDynamicForm },

  data () {
    return {
      formData: {},
      tableDescription: {},
      loading: false,
      buttonList: [
        {
          name: '返回',
          handler: this.handlerCancel,
        },
        {
          name: '保存',
          type: 'info',
          handler: this.handlerSave,
        },
      ],
    }
  },

  methods: {
    handlerCancel () {
      confirm({
        title: '小提示',
        message: '该操作会丢失您当前操作的数据，确认返回吗？',
        beforeConfirm: async (done) => {
          this.$emit('on-back')
          done()
        },
      })
    },

    async handlerSave () {
      if (!await this.$refs.formDom.validate()) {
        return
      }

      const baseInfo = {}

      Object.keys(this.formData).forEach((key) => {
        const value = this.formData[key]

        if (value instanceof Array) {
          if (value[0].url) {
            baseInfo[key] = value.map((el) => el.url).join(',')
          } else {
            baseInfo[key] = value.join(',')
          }
        } else {
          baseInfo[key] = value
        }
      })

      this.loading = true
      const data = await insertBaseInfo({
        ...baseInfo,
        pcdm: this.$route.query.pcdm,
        dzlbdm: this.$route.query.dzlbdm,
      })

      this.loading = false

      if (data.code === 0) {
        success(data.message || SAVE_SUCCESS)
        this.$emit('on-back', data)
      } else {
        danger(data.message || '报名失败')
      }
    },
  },
}
